import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { ServiceHelpersService } from '../../_helpers/service-helpers.service';

@Injectable({
  providedIn: 'root',
})
export class MileageService {
  backendPerPol: string = environment.backend_server_url;
  stringValue: any;

  constructor(
    private http: HttpClient,
    private serviceHelpers: ServiceHelpersService
  ) {}

  checkMilageValues(inputValue, arrayValue): string {
    if (inputValue.value !== '' && inputValue.dirty === true) {
      if (inputValue.value > arrayValue) {
        this.stringValue = 'ok';
      } else if (inputValue.value !== arrayValue) {
        this.stringValue = 'input was less than';
      } else {
        this.stringValue = 'values are the same';
      }
    } else {
      this.stringValue = 'input not changed';
    }

    return this.stringValue;
  }

  updateMileage(emailAddress, policyId, changeMileageDTO): Observable<any> {
    const url = `${environment.backend_server_url_policy}/${emailAddress}/${policyId}/change-mileage`;
    return this.http
      .post(url, changeMileageDTO, this.serviceHelpers.options)
      .pipe(
        map((res) => res['payload']),
        catchError(() => {
          return throwError('ok');
        })
      );
  }
}
